import { get, post } from 'lib/request';

export const getUserEmailPreferences = (opts) =>
  get('/user/mail/permissions', opts);

export const getUserWebpushPreferences = (opts) =>
  get('/user/webpush/permissions', opts);

export const postUserEmailPreference = ({ action, permission }) =>
  post('/user/mail/change-permission', {
    body: { action, mailTemplate: permission },
  });

export const postUserWebpushPreference = ({ action, permission }) =>
  post('/user/webpush/change-permission', {
    body: { action, webpushTemplate: permission },
  });
